import ImageMap from './ImageMap';

export default ImageMap;